module.exports = __webpack_public_path__ + "static/media/JNEXCH8H8.26e0bddf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/gifs/JNEXCH8H8.gif
// module id = 233
// module chunks = 0